import Transactions from "../fuselage/entries/transactions";
import Nav from "../nav/Nav";

export default function TransactionsPage() {
  return (
    <div className="">
      <div className="sticky z-50 top-0">
        <Nav />
      </div>
      <div className="max-w-[1440px] mx-auto md:px-8 py-11">
        <h1 className="text-2xl leading-9 font-[600]">Entries</h1>

        <Transactions />
      </div>
    </div>
  );
}
